import React from 'react';
import Button, {ButtonProps} from '@mui/material/Button';
import Alert, {AlertProps} from '@mui/material/Alert';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';

import config from 'cityads-v3/config';

type SnackbarButtonProps = ButtonProps & {
  message: string
  autoHideDuration: number
} & Pick<AlertProps, 'severity'>

export default function SnackbarButton({
  message,
  autoHideDuration = config.SNACKBAR_AUTOHIDE_DURATION,
  severity,
  ...rest
}: SnackbarButtonProps) {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div>
      <Button
        onClick={handleClick}
        {...rest}
      />
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        message={severity ? undefined : message}
      >
        {severity && (
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        )}
      </Snackbar>
    </div>
  );
}
